import { render } from "./footSpace.vue?vue&type=template&id=47fde622&lang=html"
import script from "./footSpace.vue?vue&type=script&lang=js"
export * from "./footSpace.vue?vue&type=script&lang=js"

import "./footSpace.vue?vue&type=style&index=0&id=47fde622&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__